import { LinkButton } from '@igs-web/common-ui-components/_atoms/link/link-button'
import styled from 'styled-components'

export const NavbarLinkButton = styled(LinkButton)`
    padding: 10px 20px;
    font-size: 0.875rem;
    line-height: 0.875rem;
`
